// @flow
import React from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";

const styles = (theme) => ({
  button: {
    margin: theme.spacing(1),
  },
});

type Props = {
  classes: Object,
};

const NotLoggedIn = ({ classes }: Props) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const handleLogin = () => {
    dispatch(push(`/login?redirect=${location.pathname}`));
  };

  return (
    <div style={{ position: "fixed", width: "100%", height: "100%" }}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100%" }}
      >
        <Grid item xs={12}>
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={12}>
              <Typography variant="h4" align="center">
                You have to log in to be able to access this part of the system.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleLogin}
                className={classes.button}
              >
                login
              </Button>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/"
                className={classes.button}
              >
                home
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(NotLoggedIn);
